// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.EnergySavingNodeCard_hr__v7Ve\\+ {
  margin-top: 0.5rem;
}

.EnergySavingNodeCard_container__Gtv9c {
  box-shadow: 0px 2px 4px rgba(130, 130, 130, 0.2509803922);
  border: 1px solid #E8E8E8;
}

.EnergySavingNodeCard_titleHeader__uyFzC {
  border-bottom: 1px solid #E8E8E8;
  padding: 1rem;
}

.EnergySavingNodeCard_childContainer__IdCk5 {
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/EnergySaving/EnergySavingNodeCard.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACI,kBAAA;AAeJ;;AAZA;EACI,yDAAA;EACA,yBAAA;AAeJ;;AAZA;EACI,gCAAA;EACA,aAAA;AAeJ;;AAZA;EACI,aAAA;AAeJ","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.hr {\n  margin-top: 0.5rem;\n}\n\n.container {\n  box-shadow: 0px 2px 4px rgba(130, 130, 130, 0.2509803922);\n  border: 1px solid #E8E8E8;\n}\n\n.titleHeader {\n  border-bottom: 1px solid #E8E8E8;\n  padding: 1rem;\n}\n\n.childContainer {\n  padding: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hr": `EnergySavingNodeCard_hr__v7Ve+`,
	"container": `EnergySavingNodeCard_container__Gtv9c`,
	"titleHeader": `EnergySavingNodeCard_titleHeader__uyFzC`,
	"childContainer": `EnergySavingNodeCard_childContainer__IdCk5`
};
export default ___CSS_LOADER_EXPORT___;
